<section class="jumbotron">
  <div class="container position-relative">
    <div class="jumbotron-content text-white text-center">
      <h1 class="font-weight-bolder text-title-header">{{'header.projects' | translate}}</h1>
    </div>
  </div>
</section>

<section class="py-4 bg-green-qaira">
  <div class="text-center text-white font-weight-bolder" style="font-size: 20px;">Calidad del aire como pilar de la seguridad industrial</div>
</section>

<section class="py-5">
  <div class="container">
    <div class="row align-items-center">

      <!-- Imagen -->
      <div class="col-12 col-lg-5 mb-4 mb-lg-0 text-center">
        <img src="../../../assets/img/proyectos/proyecto_talleres.png" alt="Imagen sección" class="img-fluid"
          style="max-width: 320px;">
      </div>

      <!-- Texto -->
      <div class="col-12 col-lg-7 text-center text-lg-start">
        <h2 class="fw-bold mb-3">Talleres Industriales de Panamá</h2>
        <p class="mb-4">
          Talleres Industriales de Panamá ha integrado nuestro módulo qHAWAX para sustentar la identificación, evaluación y prevención de riesgos laborales dentro de sus procesos. La información de nuestros equipos ha sido valiosa para sus auditorías externas de seguimiento, demostrando la utilidad de la tecnología de qAIRa en la gestión de la seguridad en el entorno industrial.
        </p>
        <!-- <a href="#" class="btn btn-success">Learn More</a> -->
      </div>

    </div>
  </div>
</section>

<section class="py-4 bg-blue-qaira">
  <div class="text-center text-white font-weight-bolder" style="font-size: 20px;">Empoderamiento ciudadano: datos para un aire limpio</div>
</section>

<section class="py-5">
  <div class="container">
    <div class="row align-items-center d-flex flex-row flex-column-reverse flex-lg-row">
      <!-- Texto -->
      <div class="col-12 col-lg-7 text-center text-lg-start">
        <h2 class="fw-bold mb-3">El Paraíso de Huachipa</h2>
        <p class="mb-4">
          Atendiendo el llamado de los vecinos de "El Paraíso de Huachipa", implementamos módulos qHAWAX en colaboración con el grupo de inteligencia artificial pucp y la municipalidad de Lima. La evidencia recopilada durante dos meses reveló altos niveles de material particulado, impulsando el cierre de una empresa informal y marcando un paso crucial hacia la mejora de su calidad de vida.
        </p>
        <!-- <a href="#" class="btn btn-success">Learn More</a> -->
      </div>
      <!-- Imagen -->
      <div class="col-12 col-lg-5 mb-4 mb-lg-0 text-center">
        <img src="../../../assets/img/proyectos/proyecto_huachipa.png" alt="Imagen sección" class="img-fluid"
          style="max-width: 320px;">
      </div>
    </div>
  </div>
</section>

<section class="py-4 bg-green-qaira">
  <div class="text-center text-white font-weight-bolder" style="font-size: 20px;">Inteligencia artificial transformando el aire urbano</div>
</section>

<section class="py-5">
  <div class="container">
    <div class="row align-items-center">

      <!-- Imagen -->
      <div class="col-12 col-lg-5 mb-4 mb-lg-0 text-center">
        <img src="../../../assets/img/proyectos/proyecto_analisis_video.png" alt="Imagen sección" class="img-fluid"
          style="max-width: 320px;">
      </div>

      <!-- Texto -->
      <div class="col-12 col-lg-7 text-center text-lg-start">
        <h2 class="fw-bold mb-3">IA PUCP</h2>
        <p class="mb-4">
          Desplegamos redes de vanguardia con nuestros módulos qHAWAX en Lima y Arequipa, capturando la calidad del aire en tiempo real. Potentes modelos de inteligencia artificial analizaron estos datos para la predicción espacial y temporal de la contaminación, ofreciendo una visión crucial para la toma de decisiones informada en entornos urbanos. Esta colaboración con la PUCP permitió explorar el potencial de la IA en la gestión ambiental urbana.
        </p>
        <!-- <a href="#" class="btn btn-success">Learn More</a> -->
      </div>

    </div>
  </div>
</section>

<section class="py-4 bg-blue-qaira">
  <div class="text-center text-white font-weight-bolder" style="font-size: 20px;">Tecnología abierta protegiendo la amazonía peruana</div>
</section>

<section class="py-5">
  <div class="container">
    <div class="row align-items-center d-flex flex-row flex-column-reverse flex-lg-row">
      <!-- Texto -->
      <div class="col-12 col-lg-7 text-center text-lg-start">
        <h2 class="fw-bold mb-3">Proyecto UNICEF</h2>
        <p class="mb-4">
          En colaboración con UNICEF, implementamos nuestro módulo qHAWAX y el drone andino para monitorear la calidad del aire en Madre de Dios, identificando posibles amenazas ambientales. Esta iniciativa impulsó el desarrollo de qAIRamap en su versión de código abierto, democratizando el acceso a información vital sobre la pureza del aire en esta importante región.
        </p>
        <!-- <a href="#" class="btn btn-success">Learn More</a> -->
      </div>
      <!-- Imagen -->
      <div class="col-12 col-lg-5 mb-4 mb-lg-0 text-center">
        <img src="../../../assets/img/proyectos/proyecto_unicef.png" alt="Imagen sección" class="img-fluid"
          style="max-width: 320px;">
      </div>
    </div>
  </div>
</section>

<section class="py-4 bg-green-qaira">
  <div class="text-center text-white font-weight-bolder" style="font-size: 20px;">Monitoreo ambiental móvil - Datos en acción</div>
</section>

<section class="py-5">
  <div class="container">
    <div class="row align-items-center d-flex flex-row flex-column-reverse flex-lg-row">
       <!-- Imagen -->
       <div class="col-12 col-lg-5 mb-4 mb-lg-0 text-center">
        <img src="../../../assets/img/proyectos/proyecto_qh_movil.png" alt="Imagen sección" class="img-fluid"
          style="max-width: 320px;">
      </div>
      <!-- Texto -->
      <div class="col-12 col-lg-7 text-center text-lg-start">
        <h2 class="fw-bold mb-3">Damero de Pizarro</h2>
        <p class="mb-4">
          Junto a la Municipalidad Metropolitana de Lima, realizamos un exhaustivo monitoreo móvil en el damero de Pizarro utilizando un vehículo eléctrico equipado con nuestros sensores y tecnología. La información recopilada durante tres meses fue fundamental para la ejecución de la peatonalización de la zona, promoviendo un entorno más saludable y sostenible.
        </p>
        <!-- <a href="#" class="btn btn-success">Learn More</a> -->
      </div>     
    </div>
  </div>
</section>

